import { Model } from 'backbone';
import { User } from '../../../core/models';
import Storage from '../../utils/Storage';
import _ from 'lodash';

/**
 * This is Share Model Class
 */
export default class ShareModel extends Model {
	defaults() {
		return {
			code:         '',
			product_name: process.env.PRODUCT_NAME,
			league_name:  '',
			prize_amount: 0,
			invite_link:  '',
			team_share:   false,
			team_info: {},
			team: {}
		};
	}

	getLeagueMessage() {
		const
			product_name   = this.get( 'product_name' ),
			league_name    = this.get( 'league_name' ),
			team_name      = User.get( 'team_name' );

		return `I entered my team ${team_name} in ` +
				`${league_name} in ${product_name}. Take the challenge and join my league now!`;
	}

	getTeamMessage() {
		let team_info = this.get( 'team_info' ),
			team      = this.get( 'team' );

		if ( !team_info.is_unlimited_trades && team.scoreflow ) {
			const roundArray = Object.keys(team.scoreflow);
			let selected_round = Storage.get('selected_round');
			let round;
			let	round_points;

			if (team.scoreflow[ selected_round ]) {
				round = selected_round;
				round_points = team.scoreflow[ selected_round ]
			} 
			else {
				round = _.last( roundArray );
				round_points = team.scoreflow[_.last( roundArray )]
			}

			return `I scored ${round_points} in round`+
				` ${round} of the NRL Fantasy game! Join the fun here`;
		}
		else {
			return `I've picked my NRL Fantasy team for the 2025 season! Join #NRLFantasy here!`;
		}
	}

	get share_message() {
		const team_share = this.get( 'team_share' );

		return ( team_share ) ? this.getTeamMessage() : this.getLeagueMessage();
	}

	share( data ) {
		switch ( data.sc ) {
			case 'tw' :
				this.shareTwitter( data );
				break;

			case 'fb' :
				this.shareFacebook( data );
				break;

			case 'whatsapp' :
				this.shareWhatsapp( data );
				break;

			default :
				throw new Error( `Need share type for this method` );
		}
	}

	shareFacebook( data ) {
		let url = this.getShareURL( data );

		window.FB.ui( {
			method:  'share',
			display: 'popup',
			href:    url
		}, () => {} );
	}

	shareTwitter( data ) {
		let link = this.getShareURL( data );
		this.set( data );

		window.open(
			'https://x.com/share?url=' + encodeURIComponent( '.' ) +
			'&text=' + encodeURIComponent( this.share_message ) + ' ' +
			link + '&hashtags=NRL,NRLFantasy',
			'twitter-share-dialog',
			'width=626,height=436'
		);
		return this;
	}

	shareWhatsapp( data ) {
		let message = encodeURIComponent( this.share_message ),
			link    = this.getShareURL( data ),
			query   = 'whatsapp://send?text=' + message + ' ' + link;

		window.open( query );
	}

	getShareFragment() {
		const
			team_share = this.get( 'team_share' ),
			league_fragment = 'share/classic_league_invite',
			team_fragment = 'share/classic_team';

		return ( team_share ) ? team_fragment : league_fragment;
	}

	getShareURL( data ) {
		//data.s = Math.floor(Math.random() * 100);
		data.s = Date.now();

		let
			share_fragment = this.getShareFragment(),
			share_url      = process.env.ABSPATH + share_fragment,
			json_data      = btoa( JSON.stringify( data ) );

		return `${'https:' + share_url}/${json_data}`;
	}
}